@if (documentUrl) {
  <div id="iframeContainer" class="flexColumnContainer">
    <iframe (load)="iframeLoaded()" frameBorder="0" [src]="documentUrl | safe" title="Document preview"></iframe>
  </div>
}
